module.exports = __webpack_public_path__ + "static/media/314.5e2767b7.svg";